export default __webpack_public_path__ + "static/media/primaryLogo.96e83793.png";